import { render, staticRenderFns } from "./LanHistory.vue?vue&type=template&id=3246da9e&scoped=true"
import script from "./LanHistory.vue?vue&type=script&lang=js"
export * from "./LanHistory.vue?vue&type=script&lang=js"
import style0 from "./LanHistory.vue?vue&type=style&index=0&id=3246da9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246da9e",
  null
  
)

export default component.exports